import { lazy } from 'react';

const SendTransformerTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/consult/send-transfer',
			component: lazy(() => import('./SendTransferContainer'))
		}
	]
};

export default SendTransformerTransferConfig;


